<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close"></div>
        <h4 v-if="detail">Edit Grup</h4>
        <h4 v-else>Buat Grup</h4>
        <div class="groupCnt" v-if="state === 0">
          <div class="groupInfo">
            <div id="groupImg" class="profilePict"
              :class="{noImg: !avatar, uploading: uploadingAvatar}"
              :style="{'background-image': `url(${avatar})`}"
              v-on:click="pickAvatar = true"></div>
            <div class="fieldGroup">
              <label>Nama Grup</label>
              <form v-on:submit.prevent="">
                <div class="fieldCnt" :class="{hasError: form.name.error}">
                  <input type="text" placeholder="Nama grup..." class="field"
                    v-model="form.name.model" v-on:input="form.name.error = null">
                  <div class="fieldError" v-if="form.name.error">
                    {{form.name.error}}</div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="groupCnt" v-else>
          <form v-on:submit.prevent="findUser">
            <div class="fieldGroup">
              <div class="fieldCnt findUser" :class="{hasError: userError}">
                <h4>Undang peserta ke dalam grup</h4>
                <input type="text" class="field" v-model="userModel"
                  v-on:input="userError = false" placeholder="Masukan Email/No. Telp peserta">
                <button type="submit" :class="{loading: findingUser}"></button>
                <div class="fieldError" v-if="userError">{{userError}}</div>
                <div class="hint" v-else>Cari dengan Email/No. Telp.</div>
              </div>
            </div>
          </form>
          <div class="memberCnt">
            <div class="memberItem" v-for="(m, i) in members" :key="i">
              <div class="profilePict" v-if="m.user.avatar"
                :style="{'background-image': `url(${m.user.avatar})`}"></div>
              <div class="profilePict noImg" v-else></div>
              {{m.user.name}}
              <div class="close" v-on:click="kickMember(i, m)"></div>
            </div>
          </div>
        </div>
        <div class="modalFooter">
          <button class="btn secondary" v-if="!loading && !isInvite"
            v-on:click="cancel">
            <span v-if="state === 0 || isInvite">Batal</span>
            <span v-else>Sebelumnya</span>
          </button>
          <button class="btn primary" :class="{btnLoading: loading}"
            v-on:click="save('published')">
            <span v-if="state === 1">Selesai</span>
            <span v-else-if="detail">Simpan</span>
            <span v-else>Berikutnya</span>
          </button>
        </div>
      </div>
      <AvatarCropper v-on:uploading="uploading" v-on:uploaded="uploaded"
        trigger="#groupImg"
        v-model="pickAvatar" :upload-url="uploadUrl"
        :output-options="{width: 600, height: 600}"
        :upload-headers="uploadHeaders"
        :labels="{submit: 'Save Avatar', cancel: 'Cancel'}"/>
      <Confirmation ref="confirmDialog"/>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import config from '../config';

export default {
  name: 'createGroup',
  components: { AvatarCropper, Confirmation, Snackbar },
  data() {
    return {
      show: false,
      next: null,
      state: 0,
      userError: null,
      members: [],
      findingUser: false,
      userModel: '',
      form: {
        name: { model: '', error: null },
      },
      loading: false,
      groupId: null,
      detail: null,
      isInvite: false,

      /**
       * Group image
       *
       */
      pickAvatar: false,
      avatar: null,
      uploadingAvatar: false,
      uploadUrl: '',
      uploadHeaders: {},
    };
  },
  methods: {
    open(d, isInvite, next) {
      this.next = next;
      this.show = true;
      this.state = 0;
      this.members = (d && d.members) ? d.members : [];
      this.userError = null;
      this.findingUser = false;
      this.userModel = '';
      this.form.name.model = (d && d.name) ? d.name : '';
      this.form.name.error = null;
      this.uploadUrl = (d && d.id)
        ? this.$config.uri(`group/${d.id}/avatar`)
        : this.$config.uri('group/avatar');
      this.detail = d;
      this.avatar = (d && d.avatar) ? d.avatar : null;
      this.groupId = (d && d.id) ? d.id : null;
      this.isInvite = isInvite;
      if (isInvite) this.state = 1;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    uploading() {
      this.avatar = null;
      this.uploadingAvatar = true;
    },
    uploaded(response) {
      this.uploadingAvatar = false;
      this.avatar = response.avatar;
      this.groupId = response.groupId;
    },
    cancel() {
      if (this.state === 1 && !this.isInvite) this.state = 0;
      else this.close(false);
    },
    save(status) {
      if (this.loading) return;
      if (this.state === 0) {
        if (!this.form.name.model || this.form.name.model === '') {
          this.form.name.error = 'Mohon isi nama grup';
          return;
        }
        this.loading = true;
        this.saveNow(status, () => {
          this.loading = false;
          if (this.detail) this.close(true);
          else this.state = 1;
        });
      } else {
        this.close(true);
      }
    },
    saveNow(status, next) {
      const formData = { name: this.form.name.model, status };
      if (this.groupId) formData.id = this.groupId;
      this.$http.post(this.$config.uri('group/save'), formData).then((r) => {
        this.loading = false;
        if (r.data.status !== 200) {
          // Display error
          return;
        }
        this.groupId = r.data.id;
        this.uploadUrl = this.$config.uri(`group/${this.groupId}/avatar`);
        if (next) next();
      });
    },
    kickMember(i, m) {
      this.$refs.confirmDialog.open({
        title: `Hapus ${m.user.name}`,
        desc: `Apakah kamu yakin ingin menghapus ${m.user.name} dari peserta grup?`,
        action: 'Hapus',
      }, (b) => {
        if (!b) return;
        this.members.splice(i, 1);
        this.$http.get(this.$config.uri(`group/member/${m.id}/kick`)).then(() => {
          this.$refs.snackbar.open({ content: `${m.user.name} dihapus dari daftar peserta grup` });
        });
      });
    },
    findUser() {
      this.findingUser = true;
      this.$http.post(this.$config.uri('user/find'), {
        user: this.userModel,
      }).then((r) => {
        this.findingUser = false;
        if (r.data.status !== 200) {
          this.userError = 'Peserta tidak ditemukan';
          return;
        }
        this.userModel = '';
        // eslint-disable-next-line
        for (const m of this.members) {
          if (m.user.id === r.data.data.id) {
            this.userError = 'Peserta sudah terdaftar';
            return;
          }
        }
        this.$http.post(this.$config.uri(`group/${this.groupId}/member/add`), {
          userId: r.data.data.id,
        }).then((r2) => {
          this.members.push({ id: r2.data.id, user: r.data.data });
        });
      });
    },
  },
  mounted() {
    this.uploadUrl = this.$config.uri('group/avatar');
    this.uploadHeaders = {
      Key: config.apiKey,
      Authoziration: this.$session.get('tufi2_jwt'),
    };
  },
};
</script>

<style scoped lang="scss">
.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
    opacity: 1;
  }
  .modalContent{
    position: absolute;
    background-color: #fff;
    // background-color: #e6e1c1;

    // background-color: #b7e4c9;
    // background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    z-index: 2;
    padding: 30px 40px 140px;
    border-radius: 5px;
    margin-top: -20px;
    overflow: hidden;
    width: 420px;
    background-image: url(../assets/FG-Kiri.svg);
    background-size: 180px auto;
    background-position: left bottom;
    background-repeat: no-repeat;
    .close{
      width: 36px; height: 36px;
      border-radius: 50%;
      position: absolute;
      right: 10px; top: 10px;
      background-image: url(../assets/close.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .7;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: rgba(0,0,0,.2);
        opacity: .6;
      }
    }
    @media (max-width: 680px) {
      width: calc(100% - 20px);
      box-sizing: border-box;
      padding: 30px 30px 140px;
      background-size: 140px auto;
      background-position: -30px 100%;
    }
    h4{
      margin: 0;
      font-size: 24px;
      font-weight: normal;
      margin-bottom: 5px;
      color: #444;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    p{
      margin: 0 0 12px;
      color: #767676;
    }
    .memberCnt{
      display: flex;
      flex-wrap: wrap;
      .memberItem{
        border: #5351a4 1px solid;
        background-color: rgba(83, 81, 164, .07);
        padding: 6px 36px 6px;
        border-radius: 50px;
        color: #5351a4;
        margin-right: 5px;
        margin-bottom: 5px;
        font-size: 14px;
        font-weight: 600;
        position: relative;
        .profilePict{
          position: absolute;
          left: 2px; top: 2px; bottom: 2px;
          width: 26px;
          border-radius: 50%;
          background-color: #999;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          &.noImg{
            opacity: .75;
            background-image: url(../assets/user.png);
          }
        }
        .close{
          position: absolute;
          right: 4px; top: 4px; bottom: 4px;
          width: 22px;
          background-size: 8px auto;
          background-image: url(../assets/close-white.png);
          padding: 0; height: auto;
          background-color: rgba(0, 0, 0, .2);
          &:hover{
            background-color: red;
          }
        }
      }
    }
    .groupCnt{
      padding: 10px 0 0;
      min-height: 200px;
      box-sizing: border-box;
      .groupInfo{
        .profilePict{
          width: 120px; height: 120px;
          background-color: #bbb;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          margin: 0 auto 10px;
          border-radius: 50%;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            opacity: .9;
            box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          }
          &.noImg{
            opacity: .36;
            background-image: url(../assets/photo-black.png) !important;
            background-size: 46px auto;
            background-position: 50% 36px;
            &:hover{
              background-color: #aaa;
              opacity: .54;
            }
          }
          &.uploading{
            background-image: url(../assets/loading.svg) !important;
            background-size: 54px auto;
            background-position: center;
            background-color: #bbb !important;
            opacity: .54;
            cursor: default;
          }
        }
      }
    }
    .fieldGroup{
      h4{
        font-size: 16px;
      }
      .fieldCnt.findUser{
        position: relative;
        button{
          position: absolute;
          right: 4px; top: 30px;
          width: 37px; height: 37px;
          border: none;
          padding: 0;
          border-radius: 3px;
          z-index: 3;
          cursor: pointer;
          background-image: url(../assets/search-white.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          transition: all .3s ease;
          background-color: #5351a4;
          &:hover{
            background-color: #615fb1;
            box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          }
          &.loading{
            background-color: #eee;
            background-image: url(../assets/loading.svg);
            background-size: 28px auto;
            cursor: default;
            box-shadow: none;
          }
        }
      }
    }
    .modalFooter{
      position: absolute;
      left: 0; right: 0; bottom: 0;
      padding: 10px 40px 16px;
      text-align: right;
      @media (max-width: 680px) {
        padding-right: 20px;
        padding-left: 20px;
      }
      .btn{
        margin-left: 10px;
        padding-top: 0;
        padding-bottom: 0;
        font-size: 16px;
        height: 44px;
        &.btnLoading{
          background-size: 26px auto;
        }
      }
    }
  }
}
</style>
